import {Component, OnInit} from '@angular/core';
import * as moment from 'moment';
import { interval } from 'rxjs';
import { IConfiguracionUsuario } from 'src/app/interfaces/usuarios';
import { PerfilamientoService } from 'src/app/services/perfilamiento/perfilamiento.service';

@Component({
  selector: 'app-view-inicio',
  templateUrl: './view-inicio.component.html',
  styleUrls: ['./view-inicio.component.scss']
})
export class ViewInicioComponent implements OnInit {
  currHour: string = ''
  user: IConfiguracionUsuario | null = null
  textoJornada: string = 'Buenas tardes'
  currSede: number = 1

   seccionId: string = "2023-" + "7-" + "16-" + "1232-" + "3453454";

  constructor(
    private _perfilamiento: PerfilamientoService,
  ) {
    this._perfilamiento.getSyncUser.subscribe(
      (res: any) => {
        if ( res !== 'logged out' ) {
          this.syncUsuario(res)
        } else {
          this.user = null
        }
      }
    )
    this.syncUsuario(this._perfilamiento.getUsuario())

    this.currHour = moment().format('HH:mm:ss')

    interval(1000).subscribe(x => {
      this.currHour = moment().format('HH:mm:ss')
      const hour = Number(moment().format('HH'))
      switch (true) {
        case hour >= 0 && hour <= 5:
          this.textoJornada = 'Buenas noches'
          break;
        case hour >= 5 && hour <= 12:
          this.textoJornada = 'Buenos días'
          break;
        case hour >= 12 && hour <= 20:
          this.textoJornada = 'Buenas tardes'
          break;
        case hour >= 20 && hour <= 24:
          this.textoJornada = 'Buenas noches'
          break;
        default:
          this.textoJornada = 'Buenas tardes'
          break;
      }
    });
  }

  getRandomIntInclusive(min: number, max: number): number {
    const randomBuffer = new Uint32Array(1)
    window.crypto.getRandomValues(randomBuffer)
    let randomNumber = randomBuffer[0] / (0xffffffff + 1)

    min = Math.ceil(min)
    max = Math.floor(max)
    return Math.floor(randomNumber * (max - min + 1)) + min
  }

  randomIntFromInterval(min: number, max: number) {
    return this.getRandomIntInclusive(min, max)
  }

  randomSedes() {
    setInterval(() => {
      this.currSede = this.randomIntFromInterval(1, 19)
    }, 15000);
  }

  ngOnInit() : void {
    this.currSede = this.randomIntFromInterval(1, 19)
    this.randomSedes()
  }

  syncUsuario(user: any) {
    this.user = user
  }

}
